import { render, staticRenderFns } from "./SiteFaq.vue?vue&type=template&id=304b63d2&scoped=true&"
var script = {}
import style0 from "./SiteFaq.vue?vue&type=style&index=0&id=304b63d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b63d2",
  null
  
)

export default component.exports